<template>
    <div>
        <div class="row d-flex align-items-center justify-content-start pl-4">
            <div class="col-10 mb-5">
                <Button
                    v-if="$route.path.includes('secondary') || !$route.path.includes('new')" 
                    @click="$router.go(-1)" 
                    class="mb-4" 
                    size="small"
                    type="outline" 
                    color="grey"
                >
                    <ArrowDropdown :rotate="90" class="mr-2" :color="`#727D94`"/>
                    Voltar
                </Button>
                <h3 class="c-ndarkthree mb-0">
                    <span class="bold">{{ partnerTitle | formatName }}</span> | Regras de cobrança
                </h3>
            </div>
            <div class="col-10 mb-5">
                <el-form :model="partner" ref="partner">
                    <h5 class="mb-3">Dados gerais</h5>
                    <div class="row mb-4">
                        <div class="col-6">
                            <el-form-item prop="name" class="mb-0">
                                <InputText  
                                    v-model="partner.name"  
                                    label="Razão social"    
                                    placeholder="Razão social"  
                                    :disabled="true"    
                                />
                            </el-form-item>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <el-form-item prop="cnpj" class="mb-0">
                                <InputText  
                                    v-model="partner.cnpj"  
                                    label="CNPJ"     
                                    v-mask="'##.###.###/####-##'"
                                    placeholder="00.000.000/0000-00"  
                                    :disabled="true"    
                                />
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="col-10 mb-5">
                <h5 class="mb-3">Nota fiscal</h5>
                <div class="mb-4">
                    <p class="bold mb-3">Qual o regime tributário da empresa?</p>
                    <el-radio :class="getPrimaryColor" v-model="partner.taxClassification" :label="'outro'">Outro</el-radio>
                    <el-radio :class="getPrimaryColor" v-model="partner.taxClassification" :label="'simples'">Simples nacional</el-radio>
                    <el-radio :class="getPrimaryColor" v-model="partner.taxClassification" :label="'fidic'">FIDIC</el-radio>
                </div>
                <div>
                    <div v-if="$route.path.includes('secondary')">
                        <p class="bold mb-3">A nota fiscal deve ser emitida para quem?</p>
                        <el-radio :class="getPrimaryColor" v-model="billingEmitedTo" :label="'parceiro'">Parceiro</el-radio>
                        <el-radio :class="getPrimaryColor" v-model="billingEmitedTo" :label="'financiador'">Financiador (fundo)</el-radio>
                    </div>
                    <div v-if="showNotes">
                        <label>Observação da nota fiscal</label>
                        <el-input  
                            type="textarea"  
                            :class="` teste ${getPrimaryColor} col-6 p-0 document-review`" 
                            v-model="billingNote" 
                            maxlength="5000"
                            placeholder="Observações" 
                        >
                        </el-input>
                    </div>
                </div>
            </div>
            <div class="col-10 mb-5" v-if="!$route.path.includes('secondary')">
                <h5 class="mb-3">Cobrança</h5>
                <el-form :model="partner" ref="partner">
                    <el-form-item prop="seller" class="col-6 p-0">
                        <label>Vendedor</label>
                            <el-select 
                                :value="partner.seller"
                                v-model="partner.seller"     
                                placeholder="Selecione o vendedor"
                                :popper-class="getPrimaryColor" 
                            >
                                <el-option label="Leandro" :value="`leandro`"/>
                                <el-option label="Klysman" :value="`klysman`" />
                                <el-option label="Fernando" :value="`fernando`" />
                            </el-select>
                    </el-form-item>
                    <el-form-item prop="indication" class="col-6 p-0">
                        <label>Indicação</label>
                            <el-select 
                                :value="partner.indication"
                                v-model="partner.indication"     
                                placeholder="Selecione a empresa"
                                :popper-class="getPrimaryColor" 
                            >
                                <el-option label="Sem indicação" :value="null"/>
                                <el-option label="Black101" :value="`black`" />
                                <el-option label="Quick Soft" :value="`quick`" />
                            </el-select>
                    </el-form-item>
                    <div class="col-6 p-0 mb-4">
                        <label class="mb-2">Teto de faturamento</label>
                        <Money
                            class="input-money"  
                            v-model="partner.billingCeiling"
                            v-bind="money"    
                        />
                    </div>
                    <div class="col-6 p-0 mb-4">
                        <label class="mb-2">Piso mínimo</label>
                        <Money
                            class="input-money"  
                            v-model="partner.minimumFloor"
                            v-bind="money"    
                        />
                    </div>
                    <div class="col-6 p-0">
                        <label class="mb-2">Custos extras</label>
                        <Money
                            class="input-money"  
                            v-model="partner.extra"
                            v-bind="money"    
                        />
                    </div>
                </el-form>
            </div>
            <div class="col-10">
                <h5>Taxas</h5>
                <div class="mb-4" v-if="!$route.path.includes('secondary')">
                    <p class="bold mb-2">As taxas devem ser multiplicadas pelo prazo?</p>
                    <el-radio :class="getPrimaryColor" v-model="partner.taxMutipliedByTerm" :label="true">Sim</el-radio>
                    <el-radio :class="getPrimaryColor" v-model="partner.taxMutipliedByTerm" :label="false">Não</el-radio>
                </div>
                <div class="mb-4">
                    <p class="bold mb-2">Qual tipo de taxa aplicar?</p>
                    <el-radio :class="getPrimaryColor" v-model="partner.taxMode" :label="'escalonada'">Escalonada</el-radio>
                    <el-radio :class="getPrimaryColor" v-model="partner.taxMode" :label="'unica'">Única</el-radio>
                </div>
                <div v-if="partner.taxMode === 'escalonada'">
                    <div class="d-flex align-items-center mb-4" v-for="(range, index) in taxRange" :key="index">
                        <div class="p-0">
                            <label>Volume de antecipação (mês)</label>
                            <Money
                                class="input-money"  
                                v-model="range.minRange"
                                v-bind="money"
                                :disabled="true"    
                            />
                        </div>
                        <p class="medium p-4">até</p>
                        <div class="p-0">
                            <label>Volume de antecipação (mês)</label>
                            <Money
                                class="input-money"  
                                v-model="range.maxRange"
                                v-bind="money"   
                            />
                        </div>
                        <div class="p-0 ml-4">
                            <label>Taxa a.m.</label>
                            <Money
                                class="input-money"  
                                v-model="range.tax"
                                v-bind="tax" 
                            />
                        </div>
                        <span @click="removeTaxRange(index)">
                            <Trash />
                        </span>
                    </div>
                    <Button size="medium" type="outline" :color="getPrimaryColor" @click="newTaxRange">
                        <svg class="mr-2" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.99983 1V9M1 5H8.99967" :stroke="getPrimaryColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Adicionar nova taxa
                    </Button>
                </div>
                <div v-if="partner.taxMode === 'unica'">
                    <div class="p-0">
                        <label>Taxa a.m.</label>
                        <Money
                            class="input-money p-0 col-4"  
                            v-model="singleTax"
                            v-bind="tax" 
                        />
                    </div>
                </div>
            </div>
            <div v-if="$route.path.includes('secondary') || !$route.path.includes('new')" class="col-10 mt-4">
                <Button @click="saveAllRules" :color="getPrimaryColor">
                    Salvar alterações
                </Button>
            </div>
        </div>
        <PartnerCard v-if="$route.path.includes('new')" @saveAllRules="saveAllRules" @toGoBack="toGoBack"/>
    </div>
</template>

<script>
//UTILS
import { Money } from 'v-money'
import _isEqual from 'lodash/isEqual'
import _cloneDeep from 'lodash/cloneDeep'
import store from '@/store'

import Trash from '@/components/icons/Trash'
import PartnerCard from '@/components/cards/PartnerCard.vue'

import updatePartnerRules from '../../api/updatePartnerRules'
import updateSponsorPartner from '../../api/updateSponsorPartner'
import insertSponsorPartnersTaxes from '../../api/insertSponsorPartnersTaxes'
import updateSponsorPartnersTaxes from '../../api/updateSponsorPartnersTaxes'
import deleteSponsorPartnersTaxes from '../../api/deleteSponsorPartnersTaxes'
import getPartnerRules from "../../api/getPartnerRules"
import getSponsorsByPartnerId from "../../api/getSponsorsByPartnerId"
import getSponsorPartnersTaxes from '../../api/getSponsorPartnersTaxes'
import getMainSponsorPartnersTaxes from '../../api/getMainSponsorPartnersTaxes'

export default {
    components: {
        Money,
        Trash,
        PartnerCard
    },
    data() {
        return {
            partner: {
                name: '',
                cnpj: '',
                taxClassification: '',
                seller: '',
                indication: '',
                billingCeiling: 0,
                minimumFloor: 0,
                extra: 0,
                taxMutipliedByTerm: true,
                taxMode: 'escalonada',
            },
            originalTaxes: [],
            taxesToBeDelete: [],
            modified: false,
            singleTax: 0,
            billingEmitedTo: 'parceiro',
            billingNote: null,
            taxRange: [{
                minRange: 0,
                maxRange: 0,
                tax: 0,
            }],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
            },
            tax: {
                thousands: '.',
                decimal: ',',
                suffix: '%',
                precision: 3
            }
        }
    },
    watch: {
        taxRange: {
            handler(newTaxes) {
                this.modified = !_isEqual(this.originalTaxes, newTaxes)
                if (this.taxRange.length > 1) {
                    this.taxRange.forEach((tx, i, txr) => {
                        if (i > 0) {
                            tx.minRange = txr[i - 1].maxRange
                        }
                    })
                }
            },
            deep: true,
        }
    },
    computed: {
        showNotes() {
            if(!this.$route.path.includes('secondary')) {
                return true
            } else if (this.$route.path.includes('secondary') && this.billingEmitedTo === 'financiador') {
                return true
            }
            return false 
        },
        partnerTitle() {
            const newPartner = this.$route.path.includes('new')
            if(newPartner) return 'Novo parceiro'
            return this.partner.name
        }
    },
    methods: {
        notifySuccess() {
            this.$notify({
                title: 'Dados salvos com sucesso.',
                message: '',
                type: 'success',
                duration: 3000,
                offset: 100,
                showClose: false,
            })
        },
        notifyError() {
            this.$notify({
                title: 'Opa! Encontramos algum erro.',
                message: '',
                type: 'error',
                duration: 3000,
                offset: 100,
                showClose: false,
                customClass: 'error'
            });
        },
        formatCnpj(cnpj) {
            let formatedCnpj = cnpj.padStart(14, '0')
            formatedCnpj = cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
            this.partner.cnpj = formatedCnpj
        },
        async getTaxes(partnerId, sponsorId) {
            const isSecondarySponsor = this.$route.path.includes('secondary')

            const mainSponsorTaxes = isSecondarySponsor ? await getMainSponsorPartnersTaxes(partnerId) : []

            let sponsorTaxes = await getSponsorPartnersTaxes(partnerId, sponsorId)

            const fromMainSponsor = (mainSponsorTaxes.length && !sponsorTaxes.length) ? true : false

            sponsorTaxes = sponsorTaxes.length ? sponsorTaxes : mainSponsorTaxes

            if (sponsorTaxes.length == 1 && fromMainSponsor) this.partner.taxMode = 'unica'

            if(sponsorTaxes.length && this.partner.taxMode === 'escalonada') {
                sponsorTaxes = sponsorTaxes.map(t => {
                    return {
                        id: fromMainSponsor ? '' : t.id,
                        minRange: t.fareMin / 100,
                        maxRange: t.fareMax / 100,
                        tax: t.operationTax,
                        sponsorId,
                    }
                })
                this.originalTaxes = _cloneDeep(sponsorTaxes)
                this.taxRange = sponsorTaxes
            } else if (sponsorTaxes.length && this.partner.taxMode === 'unica') {
                if(fromMainSponsor) sponsorTaxes[0].id = ''
                sponsorTaxes[0].sponsorId = sponsorId
                this.originalTaxes = _cloneDeep(sponsorTaxes)
                this.taxRange = sponsorTaxes                
                this.singleTax = sponsorTaxes[0].operationTax
            } 
        },
        newTaxRange() {
            if (this.taxRange.length) {
                const lastTaxRange = this.taxRange[this.taxRange.length - 1]
                const newTaxRange = {
                    minRange: lastTaxRange.maxRange,
                    maxRange: lastTaxRange.maxRange,
                    tax: 0,
                }
                this.taxRange.push(newTaxRange)
            } else {
                const newTaxRange = {
                    minRange: 0,
                    maxRange: 0,
                    tax: 0,
                }
                this.taxRange.push(newTaxRange)
            }
        },
        removeTaxRange(index) {
            if(this.taxRange[index].id) {
                this.taxesToBeDelete.push(this.taxRange[index].id)
            }
            
            this.taxRange.splice(index, 1)
        },
        async updateRules() {
            const partnerRules = {
                taxClassification: this.partner.taxClassification,
                seller: this.partner.seller,
                indication: this.partner.indication,
                billingCeiling: (this.partner.billingCeiling * 100),
                minimumFloor: (this.partner.minimumFloor * 100 ),
                extra: (this.partner.extra * 100),
                taxMutipliedByTerm: this.partner.taxMutipliedByTerm,
            }

            await updatePartnerRules(this.$route.params.partnerId, partnerRules)
        },
        async updateSponsors(partnerId, sponsorId) {
            const updateData = {
                partnerId,
                sponsorId,
                taxMode: this.partner.taxMode,
                billingEmitedTo: this.billingEmitedTo,
                billingNote: this.billingNote,
            }

            await updateSponsorPartner(updateData)
        },
        async saveAllRules() {
            try {
                const isSecondarySponsor = this.$route.path.includes('secondary')

                if(!isSecondarySponsor) await this.updateRules()
                
                const partnerId = this.$route.params.partnerId
                const sponsorId = this.$store.state.register.company.id

                await this.updateSponsors(partnerId, sponsorId)

                if (this.partner.taxMode === 'escalonada' && this.modified) {
                    for(let range of this.taxRange) {
                        const formatValues = {
                            maxRange: (range.maxRange * 100),
                            minRange: (range.minRange * 100),
                            tax: range.tax,
                        }

                        if(range.id) {
                            await updateSponsorPartnersTaxes(range.id, formatValues)
                        } else {
                            await insertSponsorPartnersTaxes(partnerId, sponsorId, formatValues)
                        }
                    }                        
                } else if (this.partner.taxMode === 'unica') {
                    const formatValues = {
                            maxRange: 0,
                            minRange: 0,
                            tax: this.singleTax,
                    }
                    
                    this.taxesToBeDelete = this.originalTaxes.map(ot => ot.id)
                    await insertSponsorPartnersTaxes(partnerId, sponsorId, formatValues)
                }

                await deleteSponsorPartnersTaxes(this.taxesToBeDelete)
                await this.getTaxes(partnerId, sponsorId)
                this.notifySuccess()
                
                if(this.$route.path.includes('new')) this.$router.push('/partners')
            } catch (err) {
                this.notifyError()
            }
        },
        toGoBack() {
            return this.$router.go(-1)
        }
    },
    async created() { 
        store.commit('user/setLoading', true)
        const isSecondarySponsor = this.$route.path.includes('secondary')

        this.partner.name = this.$store.state.register.company.name
        this.formatCnpj(this.$store.state.register.company.cnpj.cnpj)
        this.partner.taxClassification = this.$store.state.register.company.taxClassification

        const partnerId = this.$route.params.partnerId
        const sponsorId = this.$store.state.register.company.id

        const partnerRules = await getPartnerRules(partnerId)
        let sponsorRules =  await getSponsorsByPartnerId(partnerId, sponsorId)
        sponsorRules = sponsorRules[0].sponsors[0].sponsorPartners
        
        if (partnerRules && !isSecondarySponsor) {
            this.partner.seller = partnerRules.seller
            this.partner.indication = partnerRules.indication
            this.partner.billingCeiling = partnerRules.billingCeiling / 100
            this.partner.minimumFloor = partnerRules.minimumFloor / 100
            this.partner.extra = partnerRules.extra / 100
            this.partner.taxMutipliedByTerm = partnerRules.taxMutipliedByTerm
        }

        this.partner.taxMode = sponsorRules.taxMode ?? "escalonada"
        this.billingNote = sponsorRules.billingNote

        await this.getTaxes(partnerId, sponsorId)

        store.commit('user/setLoading', false)
    }
}
</script>

<style lang="scss">
    .input-money:disabled{
        background-color: #f5f7fa;
    }
</style>
